import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 에러 화면
import notFound from '../views/errorpage/NotFound.vue'
import notAuth from '../views/errorpage/NotAuthenticated.vue'

// 메인 화면
const home = () => import(/* webpackChunkName: "home" */ '../views/home.vue')
const about = () => import(/* webpackChunkName: "about" */ '../views/about.vue')
const team = () => import(/* webpackChunkName: "team" */ '../views/team.vue')
const portfolios = () => import(/* webpackChunkName: "portfolios" */ '../views/portfolios.vue')
const notice = () => import(/* webpackChunkName: "notice" */ '../views/notice.vue')
const contact = () => import(/* webpackChunkName: "contact" */ '../views/contact.vue')

const routes = [
	{ path: '*', name: 'notfound', component: notFound },
	{ path: '/block', name: 'block', component: notAuth },
	{
		path: '/',
		name: 'home',
		component: home,
	},
	{
		path: '/about',
		name: 'about',
		component: about,
	},
	{
		path: '/team',
		name: 'team',
		component: team,
	},
	{
		path: '/portfolios',
		name: 'portfolios',
		component: portfolios,
	},
	{
		path: '/notice',
		name: 'notice',
		component: notice,
	},
	{
		path: '/contact',
		name: 'contact',
		component: contact,
	},
]

const router = new VueRouter({
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	base: process.env.BASE_URL,
	routes,
})

export default router
